// extracted by mini-css-extract-plugin
export default {"dnb_header_inbox_button":"InboxButton-module--dnb_header_inbox_button--1438e"};